module.exports = __webpack_public_path__ + "img/DeliveredDefault.3d5ca1a3.svg";